import { atom } from "recoil";

export const selectedClientIdState = atom({
  key: "selectedClientIdState",
  default: null,
});
